import React, {useState} from "react";
import styles from "./AddToWishlistButton.module.scss";
import {useTranslation} from "react-i18next";
import WishlistHeart from "../WishlistHeart";
import {useWishlistContext} from "../WishlistContextProvider/WishlistContextProvider";

type AddToWishlistButtonPropsType = {
  itemId: number;
  animated?: boolean;
  emptyColor?: string;
  filledColor?: string;
  size?: number;
  showAsText?: boolean;
};

const AddToWishlistButton: React.FC<AddToWishlistButtonPropsType> = ({
  itemId,
  animated = false,
  emptyColor = "#1ba1e2",
  filledColor = "#1ba1e2",
  size = 28,
  showAsText,
}) => {
  const {wishlist, addOrDeleteItem} = useWishlistContext();
  const isAlreadyAdded = !!wishlist?.items.some(({item}) => item.itemId === itemId);
  const {t} = useTranslation("customerAccount");
  const [isLoading, setIsLoading] = useState(false);
  const [toggleAnimate, setToggleAnimated] = useState(false);

  const handleItem = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (isLoading) {
      return;
    }

    setToggleAnimated(true);
    setTimeout(() => {
      setToggleAnimated(false);
    }, 400);
    setIsLoading(true);

    void addOrDeleteItem(itemId).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <div
      className={!animated ? styles.wrapper : `${styles.wrapperAnimated} ${toggleAnimate ? `${styles.reaction}` : ""}`}
      onClick={handleItem}
      title={t("Zur Wunschliste hinzufügen")}
    >
      {isLoading && !animated && <div className={styles.loaderWrapper} />}
      {showAsText && !isAlreadyAdded ? (
        <span>{t("Auf die Wunschliste")}</span>
      ) : (
        (!isLoading || animated) && (
          <WishlistHeart filled={isAlreadyAdded} color={isAlreadyAdded ? filledColor : emptyColor} size={size} />
        )
      )}
    </div>
  );
};

export default AddToWishlistButton;
